module.exports = __webpack_public_path__ + "static/img/policeCard.2b0aae3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/policeCard.png
// module id = A5uc
// module chunks = 1